const BUTTONDOWN_API_KEY = process.env.REACT_APP_BUTTONDOWN_API_KEY;
const BUTTONDOWN_API_URL = 'https://api.buttondown.com/v1/subscribers';

export const subscribeToButtondown = async (email) => {
  try {
    // Check if API key is available
    if (!BUTTONDOWN_API_KEY) {
      console.error('Buttondown API key is not configured');
      return { 
        success: false, 
        error: 'API key not configured. Please contact support.' 
      };
    }

    console.log('Attempting to subscribe with API key:', BUTTONDOWN_API_KEY ? 'Present' : 'Missing');

    const response = await fetch(BUTTONDOWN_API_URL, {
      method: 'POST',
      headers: {
        'Authorization': `Token ${BUTTONDOWN_API_KEY}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email_address: email,
        referrer_url: window.location.href,
        tags: ['waitlist', 'rentwise-web']
      })
    });

    console.log('Response status:', response.status);

    if (!response.ok) {
      let userMessage = 'Something went wrong. Please try again.';
      try {
        const errorData = await response.json();
        let rawMessage = '';
        if (Array.isArray(errorData.detail)) {
          rawMessage = errorData.detail.map(d => (d && d.msg) ? d.msg : String(d)).join(' ');
        } else if (errorData.detail) {
          rawMessage = String(errorData.detail);
        }
        rawMessage = (rawMessage + ' ' + (errorData.message || '') + ' ' + (errorData.error || '')).toLowerCase();

        if (rawMessage.includes('blocked') || rawMessage.includes('firewall')) {
          userMessage = "We couldn't add this email right now. Please try again later or use a different email address.";
        } else if (rawMessage.includes('invalid') || rawMessage.includes('value is not a valid email')) {
          userMessage = 'Email address is invalid.';
        } else if (rawMessage.includes('already subscribed') && rawMessage.includes('has not confirmed')) {
          userMessage = "This email is on our waitlist but hasn't been confirmed. Check your inbox for the confirmation email.";
        } else if (rawMessage.includes('already subscribed')) {
          userMessage = "This email is already on our waitlist.";
        }
      } catch (_) {
        userMessage = 'Something went wrong. Please try again.';
      }
      throw new Error(userMessage);
    }

    const data = await response.json();
    console.log('Successfully subscribed:', data);
    return { success: true, data };
  } catch (error) {
    console.error('Buttondown subscription error:', error);
    console.error('Error type:', typeof error);
    console.error('Error message:', error?.message);
    console.error('Full error object:', JSON.stringify(error, null, 2));
    
    const errorMessage = error?.message || error?.toString() || 'Unknown error occurred';
    return { success: false, error: errorMessage };
  }
};

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
